import HotelDetailsPage from '@hotels-hotel-detail/features/HotelDetailsPage';
import { getPageData } from '@hotels-hotel-detail/router/loader';
import { PagePropsProvider } from '@shared/data-access-frontend/contexts/props-context';
import { ValidationError, NotFoundError } from '@shared/utils-backend/errors';
import { data, useLoaderData } from 'react-router';

import { useIsProductionEnv } from '../providers/useIsProductionEnv';

import type { ExtractLoaderData } from '../types';
import type {
  QueryParams,
  RouteHandlerResult,
} from '@shared/types/backend/page-route/details-page-route';
import type { AppLoadContext, LoaderFunctionArgs } from 'react-router';

export async function loader({
  context: {
    config,
    context,
    gateway,
    hasValidationError,
    i18nService,
    jhaToken,
    logger,
    params,
    userContext,
  },
  request,
}: LoaderFunctionArgs<AppLoadContext>) {
  const url = new URL(request.url);
  const hasQueryParams = url.search.length > 0;
  const referer = request.headers.get('referer');

  try {
    if (hasValidationError) {
      throw new ValidationError('Required params are missing or invalid');
    }

    const pageData = await getPageData({
      config,
      context,
      gateway,
      i18n: i18nService,
      logger,
      params: params as QueryParams,
      userContext,
      referer,
      hasQueryParams,
      jhaToken,
    });

    return data(pageData as RouteHandlerResult);
  } catch (error) {
    if (error instanceof ValidationError) {
      throw new Response(error.message, {
        status: 403,
      });
    }

    if (error instanceof NotFoundError) {
      throw new Response(error.message, {
        status: 404,
      });
    }

    throw error;
  }
}

export { shouldRevalidateProvider as shouldRevalidate } from '../providers/shouldRevalidateProvider';

export { metaProvider as meta } from '../providers/metaProvider';

export default function HotelsHotelDetail() {
  const { props } = useLoaderData<ExtractLoaderData<typeof loader>>();
  const isProductionEnv = useIsProductionEnv();

  return (
    <PagePropsProvider value={{ ...props, isProductionEnv }}>
      <HotelDetailsPage {...props} />
    </PagePropsProvider>
  );
}
